import { useState } from 'react'
import type { FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { adminApi } from '../services/api'

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setError('')
    setIsLoading(true)

    try {
      await adminApi.requestAdminPasswordReset(email)
      setSubmitted(true)
    } catch (err) {
      setError('Unable to send reset email. Please try again.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--color-forest-dark)',
        display: 'grid',
        placeItems: 'center',
        padding: '24px',
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          width: '100%',
          maxWidth: '420px',
          background: 'var(--color-white)',
          borderRadius: '20px',
          padding: '40px',
          boxShadow: '0px 24px 64px rgba(15,46,42,0.20)',
        }}
      >
        <div style={{ marginBottom: '24px' }}>
          <div
            className="font-display"
            style={{
              color: 'var(--color-gold)',
              fontSize: '26px',
              fontWeight: 700,
              marginBottom: '4px',
            }}
          >
            Reset Password
          </div>
          <div
            className="font-body"
            style={{
              color: 'var(--color-muted)',
              fontSize: '14px',
              fontWeight: 400,
            }}
          >
            Enter your admin email to receive a reset link.
          </div>
        </div>

        <input
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          type="email"
          placeholder="Email address"
          autoComplete="email"
          required
          disabled={submitted}
          style={{
            width: '100%',
            height: '48px',
            border: '1.5px solid var(--color-border)',
            borderRadius: '10px',
            padding: '14px 16px',
            fontFamily: 'DM Sans, sans-serif',
            fontSize: '14px',
            marginBottom: '12px',
            color: 'var(--color-dark)',
          }}
        />

        {error ? (
          <p
            className="font-body"
            style={{
              marginTop: '-6px',
              marginBottom: '12px',
              fontSize: '13px',
              color: 'var(--color-error)',
            }}
          >
            {error}
          </p>
        ) : null}

        {submitted ? (
          <p
            className="font-body"
            style={{
              marginTop: '-6px',
              marginBottom: '12px',
              fontSize: '13px',
              color: 'var(--color-forest-dark)',
            }}
          >
            Check your email for a reset link. If an account exists, it will arrive shortly.
          </p>
        ) : null}

        <button
          disabled={isLoading || submitted}
          type="submit"
          className="font-body"
          style={{
            width: '100%',
            height: '48px',
            border: 'none',
            borderRadius: '999px',
            background: 'var(--color-gold)',
            color: 'var(--color-dark)',
            fontSize: '15px',
            fontWeight: 600,
            cursor: isLoading || submitted ? 'not-allowed' : 'pointer',
            opacity: isLoading || submitted ? 0.9 : 1,
            transition: 'opacity 0.2s ease',
          }}
          onMouseEnter={(event) => {
            if (!isLoading && !submitted) {
              event.currentTarget.style.opacity = '0.9'
            }
          }}
          onMouseLeave={(event) => {
            event.currentTarget.style.opacity = isLoading || submitted ? '0.9' : '1'
          }}
        >
          {isLoading ? 'Sending...' : 'Send reset link'}
        </button>

        <div style={{ marginTop: '16px', textAlign: 'center' }}>
          <Link
            to="/login"
            className="font-body"
            style={{
              fontSize: '13px',
              color: 'var(--color-muted)',
              textDecoration: 'none',
            }}
          >
            Back to login
          </Link>
        </div>
      </form>
    </div>
  )
}
